export default {
  apiPrefix: '/api/v1/',
  gaId: 'UA-167876657-1',
};
